<template>
  <div class="upload-box">
    <div class="content">
      <div class="header">
        <div class="label">上传文件</div>
        <div class="line"></div>
        <div class="close cursor" @click="closeUpload">
          <img src="/assets/images/video/upload-close.png">
        </div>
      </div>
      <div class="upload">

        <div class="add-video add-video-progress" v-if="isUpload">
          <div class="text">
            <div>{{ uploadFile.name }}</div>
            <div>{{ uploadTips }}</div>
          </div>
          <div class="progress">
            <a-progress :percent="uploadPercent" />
          </div>
          <div class="btn" @click="cancelUpload" v-if="uploadPercent < 100">取消上传</div>
        </div>

        <a-upload name="file" :showUploadList="false" :customRequest="customRequest" v-else>
          <div class="add-video cursor">
            <a-icon type="upload" style="font-size: 50px;color: #888;" />
            <div class="text">
              <span>将文件拖拽到此处也可上传</span>
            </div>
            <div class="btn">选择文件</div>
          </div>
        </a-upload>
      </div>
    </div>

  </div>
</template>
<script>
import api from "@/repo/api";
// import video from "@/utils/video";
const qiniu = require('qiniu-js');

export default {
  props: {
    /** 控制隐藏 */
    value: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isUpload: false,
      uploadFile: null,
      uploadPercent: 0,
      uploadTips: '',
      subscription: null,
    }
  },
  methods: {
    // 取消上传
    cancelUpload() {
      this.subscription.unsubscribe();
      this.isUpload = false;
      this.uploadFile = null;
      this.uploadPercent = 0;
    },
    closeUpload() {
      this.isUpload = false;
      this.uploadFile = null;
      this.uploadPercent = 0;
      this.$emit('uploadClose');
    },
    customRequest(e) {
      const file = e.file;
      this.$loading.show();
      this.uploadFileFun(file);

      // video.checkH264(file).then(() => {

      //   let size = Number(e.file.size) / 1024 / 1024;

      //   if (size < 5) {
      //     return this.$message.error('视频不能小于5MB');
      //   }

      //   this.uploadVideo(e.file);

      // }).catch(e => {

      //   this.$message.error(e);

      // }).finally(() => {

      //   this.$loading.hide();

      // })
    },
    uploadFileFun(file) {
      let _this = this;
      // file.name = file.name.split('.')[0];
      api.post('/com/qi-niu-upload-token', { file_name: file.name, file_size: file.size }, res => {
        if (res.code == 0) {
          let token = res.data.token;
          let key = res.data.key;

          const config = {
            chunkSize: 4,
            useCdnDomain: true,
            region: qiniu.region.z2
          };

          const observable = qiniu.upload(file, key, token, config);

          var observer = {
            next(res) {
              let percent = Number(res.total.percent.toFixed(2));
              _this.uploadPercent = percent;
            },
            error(res) {
              console.log(111, res);
              // res.data.error中包含limited mimeType，就提示文件类型错误
              if (res.data.error.indexOf('limited mimeType') != -1) {
                _this.$message.error('文件类型错误');
                _this.isUpload = false;
                _this.uploadFile = null;
                _this.uploadPercent = 0;
                return;
              }
            },
            complete(res) {
              if (res.code == 0) {
                _this.$loading.show();
                setTimeout(() => {
                  _this.$loading.hide();
                  _this.$emit('uploadSuccess',res.data);
                }, 1000)
              }
            },
          };

          _this.subscription = observable.subscribe(observer) // 上传开始
          console.log('subscription', _this.subscription);
        } else {
          _this.$message.error(res.msg);
          this.isUpload = false;
          this.uploadFile = null;
          this.uploadPercent = 0;
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.upload-box {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;

  .content {
    width: 408px;
    background: #FFFFFF;
    border-radius: 2px;
    padding: 24px;
    position: relative;

    .header {
      .close {
        width: 56px;
        height: 56px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
        right: 0;

        img {
          width: 16px;
          height: 16px;
        }
      }

      .label {
        color: #333333;
        font-size: 16px;
        font-weight: bold;
        line-height: 22px;
      }

      .line {
        width: 360px;
        height: 1px;
        background: #EEEEEE;
        margin: 16px 0;
      }
    }

    .upload {
      width: 360px;
      height: 300px;

      .add-video {
        width: 360px;
        height: 300px;
        border-radius: 8px;
        border: 1px dashed #999999;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .progress {
          width: 80%;
          margin: 32px auto 0;
        }

        .text {
          color: #333333;
          font-size: 14px;
          margin-top: 16px;
          text-align: center;
        }

        .btn {
          width: fit-content;
          margin: 64px auto 0;
        }

        &:hover {
          border-color: #1890FF;
        }
      }

      .add-video-progress {
        &:hover {
          border: 1px dashed #999999;
        }
      }
    }

  }
}
</style>